export default __webpack_public_path__ + "static/media/H0004.533663a2.png";